import React, { useEffect, useState } from 'react';
import { useFormik } from 'formik';
import { StatusCodes } from 'http-status-codes';
import { useHistory, useParams, useLocation } from 'react-router-dom';
import { InventoryFormikValuesDto } from '../../../../types/InventoryFormikValuesDto';
import { formikToTransactionAddDto } from '../../../../types/convertors/formikToTransactionAddDto';
import { stockTransactionGetDtoToFormik } from '../../../../types/convertors/stockTransactionGetDtoToFormik';
import WhitePad from '../../../../components/common/WhitePad/WhitePad';
import InventoryApi from '../../../../services/api/InventoryApi';
import TitleComponent from '../../../../components/common/forms/Title/TitleComponent';
import GenericProductsApi from '../../../../services/api/GenericProductsApi';
import InventoryAddEditForm from '../components/InventoryAddEditForm';
import { fullSchema } from '../InventorySchema';

interface ParamProps {
  genericId: string;
}

export default function InventoryEdit(): JSX.Element {
  const { genericId } = useParams<ParamProps>();
  const history = useHistory();
  const location = useLocation();
  const { item } = location?.state ?? {};
  const [generic, setGeneric] = useState(null);

  const saveItem = async (
    values: InventoryFormikValuesDto,
    setSubmitting: (isSubmitting: boolean) => void,
  ): Promise<void> => {
    setSubmitting(true);
    const newValues = formikToTransactionAddDto(values, genericId);
    const result = await InventoryApi.edit(newValues, item.id);

    if (result.status === StatusCodes.OK) {
      history.push(`/inventory/list-for-generic/${genericId}`);
    } else {
      setSubmitting(false);
    }
  };

  const getGenericItem = async (): Promise<void> => {
    const result = await GenericProductsApi.get(genericId);
    setGeneric(result.data);
  };

  const initialValues = stockTransactionGetDtoToFormik(item);
  const formik = useFormik({
    initialValues,
    validationSchema: fullSchema,
    onSubmit: async (values, { setSubmitting }) => {
      return saveItem(values, setSubmitting);
    },
  });

  useEffect(() => {
    if (genericId) {
      getGenericItem();
    }
  }, []);

  return (
    <WhitePad isFluid>
      <TitleComponent
        onLeftHandler={(): void => {
          history.push(`/inventory/select-product`);
        }}
        title="Edit Transaction"
      />
      {generic && <InventoryAddEditForm formikProps={formik} generic={generic} />}
    </WhitePad>
  );
}
